import { render, staticRenderFns } from "./CreatePickUp.vue?vue&type=template&id=58a34fd0"
import script from "./CreatePickUp.vue?vue&type=script&lang=js"
export * from "./CreatePickUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports